module.exports = __webpack_public_path__ + "img/epr@2x.f4013598.jpeg";